import TamanioCreate from './TamanioCreate'
export {TamanioCreate}
export default TamanioCreate
